import { api } from './api';

export type HealthStatus = 'ok' | 'fail' | string;

/** Svar fra det enkelte modul: GET /health. */
export interface ModuleHealth {
  status?: HealthStatus;
  module?: string;
  version?: string;
  db?: HealthStatus;
  nats?: HealthStatus;
  /** Core kan tilfoeje en fejlbesked, hvis modulet ikke svarede. */
  error?: string;
  [key: string]: unknown;
}

/** Aggregeret svar fra core: GET /api/health. */
export interface HealthResponse {
  status?: HealthStatus;
  /** Systemversionen (repo-rodens VERSION) fra kontrakt 0.3.2. */
  version?: string;
  /** Core-modulets egen version (kontrakt 0.3.2). */
  core_version?: string;
  modules?: Record<string, ModuleHealth>;
  [key: string]: unknown;
}

export function getHealth(signal?: AbortSignal): Promise<HealthResponse> {
  return api.get<HealthResponse>('/api/health', { silent: true, signal });
}

/** Svar fra GET /api/version (kontrakt 0.3.2). */
export interface VersionResponse {
  system_version?: string;
  module?: string;
  module_version?: string;
}

export function getVersion(signal?: AbortSignal): Promise<VersionResponse> {
  return api.get<VersionResponse>('/api/version', { silent: true, signal });
}

/** Svar fra GET /api/changelog (kontrakt 0.3.2). `markdown` er hele CHANGELOG.md. */
export interface ChangelogResponse {
  system_version?: string;
  markdown?: string;
}

export function getChangelog(signal?: AbortSignal): Promise<ChangelogResponse> {
  return api.get<ChangelogResponse>('/api/changelog', { silent: true, signal });
}
